"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DroppedItem = void 0;
const gotti_1 = require("gotti");
const types_1 = require("../../Shared/types");
const Component_1 = require("../Systems/ItemDrop/Component");
class DroppedItem extends gotti_1.Entity {
    constructor(droppedItemSeq) {
        super(droppedItemSeq, types_1.EntityTypes.DroppedItem);
    }
    initialize(data) {
        this.gameObject = data.gameObject;
        this.gameObject.entity = this;
        this.addComponent(new Component_1.ItemDropComponent(data.itemName));
    }
}
exports.DroppedItem = DroppedItem;
//# sourceMappingURL=module.js.map